import React from 'react'

export const OpenQuoteIcon = ({ color }) => (
  <svg
    width="26"
    height="25"
    viewBox="0 0 26 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.73023 17.9197C10.6341 18.1099 12.1572 16.0336 12.1572 14.3838C12.1572 13.527 11.8026 12.6625 11.0659 12.1127C10.3198 11.5558 9.62244 10.8658 9.91641 9.98235C10.2266 9.05022 10.6854 8.02484 11.0307 7.62802C11.1716 7.47196 11.1526 7.2322 10.9965 7.09136C10.9241 7.03047 10.8327 7.00001 10.7452 7.00001C10.65 7.00001 10.5395 7.02791 10.4837 7.0558C10.4279 7.08369 10.3721 7.11158 10.3164 7.13947C10.2606 7.16737 10.1816 7.22077 10.1321 7.24742C8.60139 8.02385 6.61311 10.2428 6.00767 11.5521C5.65736 12.3133 5.46316 13.2039 5.46316 14.0413C5.46316 14.1555 5.46697 14.2697 5.4746 14.3838C5.60024 16.3097 6.90777 17.7377 8.73023 17.9197Z"
      fill={color}
    />
    <path
      d="M17.1746 18.0086C19.0785 18.1987 20.6016 16.1225 20.6016 14.4727C20.6016 13.6159 20.2469 12.7514 19.5103 12.2016C18.7642 11.6447 18.0668 10.9546 18.3607 10.0712C18.6709 9.13908 19.1297 8.1137 19.4751 7.71689C19.616 7.56083 19.5969 7.32107 19.4408 7.18022C19.3685 7.11934 19.2771 7.08888 19.1895 7.08888C19.0943 7.08888 18.9838 7.11677 18.928 7.14466C18.8723 7.17256 18.8165 7.20045 18.7607 7.22834C18.7049 7.25623 18.626 7.30964 18.5765 7.33628C17.0457 8.11271 15.0574 10.3317 14.452 11.641C14.1017 12.4022 13.9075 13.2928 13.9075 14.1301C13.9075 14.2443 13.9113 14.3585 13.9189 14.4727C14.0446 16.3986 15.3521 17.8266 17.1746 18.0086Z"
      fill={color}
    />
  </svg>
)
